import { render, staticRenderFns } from "./FormSection.vue?vue&type=template&id=6eb0b903&scoped=true"
import script from "./FormSection.vue?vue&type=script&lang=ts"
export * from "./FormSection.vue?vue&type=script&lang=ts"
import style0 from "./FormSection.vue?vue&type=style&index=0&id=6eb0b903&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eb0b903",
  null
  
)

export default component.exports